import type { CodeItem } from '@/types';

export const DISCOUNT_STORAGE_KEY = 'checkout-discount-codes';
export const GIFTCARD_STORAGE_KEY = 'checkout-giftcard-codes';

export function loadCodesFromStorage(
  type: typeof DISCOUNT_STORAGE_KEY | typeof GIFTCARD_STORAGE_KEY
): CodeItem[] {
  try {
    const stored = localStorage.getItem(type);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading codes from localStorage:', error);
  }

  return [];
}
